import React, { createContext, FC, useContext } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import { CurrentUserProvider_data$key } from '__generated__/CurrentUserProvider_data.graphql';

type CurrentUser = {
  id: string;
  name: string;
  email: string;
  itemsPerPage: number;
  canPublish: boolean;
};

const CurrentUserContext = createContext<CurrentUser>({
  id: '',
  name: '',
  email: '',
  itemsPerPage: 25,
  canPublish: false,
});

type Props = {
  data: CurrentUserProvider_data$key;
};

export const useCurrentUser = () => useContext(CurrentUserContext);

const CurrentUserProvider: FC<Props> = ({ children, data }) => {
  const { viewer } = useFragment(
    graphql`
      fragment CurrentUserProvider_data on Query {
        viewer {
          id
          name
          email
          itemsPerPage
          canPublish
        }
      }
    `,
    data
  );

  const value = {
    ...viewer!,
    itemsPerPage: viewer!.itemsPerPage ?? 50,
  };

  return (
    <CurrentUserContext.Provider value={value}>
      {children}
    </CurrentUserContext.Provider>
  );
};

export default CurrentUserProvider;
